module.exports = __webpack_public_path__ + "img/Cas9variants_M.fdbb7b9d.svg";